document.addEventListener('alpine:init', () => {
  const minimumRental = document.querySelector('.product-quantity')?.getAttribute('min');
  Alpine.data('QuantityStepper', () => {
    return {
      quantity: minimumRental || 1,
      init() {
        console.log(this.quantity)
        if (this.dropdownQuantity) {
          if (this.dropdownQuantity === '10+') {
            this.quantity = 10;
          } else {
            this.quantity = parseInt(this.dropdownQuantity, 10);
          }
        }
      },
      dispatchInputChange() {
        this.$refs.quantityInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      },
      decreaseQuantity() {
        if(this.quantity > minimumRental){
          this.quantity > 1 && this.quantity--;
          this.dispatchInputChange();
        }
      },
      increaseQuantity() {
        this.quantity++;
        this.dispatchInputChange();
      },
    };
  });
});
